import { render, staticRenderFns } from "./AsociarEtiquetas.vue?vue&type=template&id=4fbc0694&"
import script from "./AsociarEtiquetas.vue?vue&type=script&lang=ts&"
export * from "./AsociarEtiquetas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fbc0694', component.options)
    } else {
      api.reload('4fbc0694', component.options)
    }
    module.hot.accept("./AsociarEtiquetas.vue?vue&type=template&id=4fbc0694&", function () {
      api.rerender('4fbc0694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/AsociarFlotaEtiquetaVehiculo/AsociarEtiquetas.vue"
export default component.exports